import * as questionIds from "../../questions/questionIds";

export const oeukQuestions = [{
    id: questionIds.WhenWasYourLastOffshoreMedical,
    questionText: "When was your last offshore medical?"
}, {
    id: questionIds.WhenWasYourLastSurvivalCourse,
    questionText: "When was your last survival course?"
}, {
    id: questionIds.HaveYouPreviouslyHadAHearingTest,
    questionText: "Have you previously had a hearing test?"
}, {
    id: questionIds.HearingTestWasItNormal,
    questionText: "Was it normal?"
}, {
    id: questionIds.HaveYouEverBeenExposedToAsbestos,
    questionText: "Have you ever been exposed to asbestos?"
}, {
    id: questionIds.HaveYouEverHadALungFunctionTest,
    questionText: "Have you ever had a lung function test?"
}, {
    id: questionIds.HaveYouEverHadAWorkRelatedMedicalCondition,
    questionText: "Have you ever had a work-related medical condition?"
}, {
    id: questionIds.HaveYouEverHadAnAccidentAtWork,
    questionText: "Have you ever had an accident at work?"
}, {
    id: questionIds.HadAnyTimeOffWork4WeeksOrMoreInTheLast5Years,
    questionText: "Had any time off work (4 weeks or more) in the last 5 years?"
}, {
    id: questionIds.HaveYouEverBeenMedivacedFromAnOffshoreInstallation,
    questionText: "Have you ever been medivaced from an offshore installation?"
}, {
    id: questionIds.HowManyCigarsDoYouSmokePerWeek,
    questionText: "How many cigars do you smoke per week?"
}, {
    id: questionIds.HowMuchPipeOrRollingTobaccoDoYouSmokePerWeek,
    questionText: "How much pipe or rolling tobacco do you smoke per week?"
}, {
    id: questionIds.DidYouVapeOrUseECigarettes,
    questionText: "Did you vape or use e-cigarettes?"
}, {
    id: questionIds.HaveYouEverHadVaricoseVeins,
    questionText: "Have you ever had varicose veins?"
}, {
    id: questionIds.HaveYouEverHadLiverDiseaseIncludingJaundiceHepatitis,
    questionText: "Have you ever had liver disease ( including jaundice/hepatitis)?"
}, {
    id: questionIds.DoYouHaveAChangeInBowelHabitsOrDiarrhoea,
    questionText: "Do you have a change in bowel habits or diarrhoea?"
}, {
    id: questionIds.HaveYouEverHadBloodInStoolsPilesOrHaemorrhoids,
    questionText: "Have you ever had blood in stools, piles or haemorrhoids?"
}, {
    id: questionIds.HaveYouAnyHistoryOfAnyProblemsWithYourBladderOrKidneys,
    questionText: "Have you any history of any problems with your  bladder or kidneys?"
}, {
    id: questionIds.HaveYouAnyHistoryOfAnyInfectiousDiseases,
    questionText: "Have you any history of any infectious diseases (apart from childhood illnesses) including sexually transmitted or tropical diseases?"
}, {
    id: questionIds.HaveYouEverHadAnyOperations,
    questionText: "Have you ever had any operations?"
}, {
    id: questionIds.HaveYouBeenTreatedInHospitalInTheLast5Years,
    questionText: "Have you been treated in hospital in the last 5 years?"
}, {
    id: questionIds.AreYouAwaitingAnyFormOfMedicalTreatmentInHospital,
    questionText: "Are you awaiting any form of medical treatment in hospital, by your GP, a physiotherapist or counsellor etc?"
}, {
    id: questionIds.DoYouHaveAFearOfFlyingOrHeights,
    questionText: "Do you have a fear of flying or heights?"
}, {
    id: questionIds.HaveYouAttendedADentistInTheLastYear,
    questionText: "Have you attended a dentist in the last year?"
}, {
    id: questionIds.AreYouUndergoingDentalTreatment,
    questionText: "Are you undergoing dental treatment?"
}, {
    id: questionIds.IfYesToAnyOfTheAbovePleaseProvideFurtherComments,
    questionText: "If yes to any of the above, please provide further comments:"
}];
